import { useEffect, useState } from "react";
import { statusConst } from "../const";

const useLiveLocation = ({
  wsConnection,
  messageMapping,
  topic,
  onMessage,
  beforeSend,
  active = true,
  autoUnsubscribe = true,
  checkForDuplicateSubscriptions = false,
  autoDisconnect = true,
}) => {
  const [wsStatus, setWsStatus] = useState(statusConst.IDLE);
  const [connected, setConnected] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(
    "Establishing Connection",
  );

  // Connecting to WebSocket.
  useEffect(() => {
    (async () => {
      if (active) {
        try {
          setWsStatus(statusConst.PENDING);
          await wsConnection.connect();
          setConnected(true);
          setLoadingMessage("Fetching Live location");
        } catch (e) {
          setWsStatus(statusConst.FAILURE);
          setLoadingMessage("Error occurred while establishing connection");
        }
      }
    })();

    return () => {
      if (active && autoDisconnect) {
        wsConnection.disconnect();
      }
    };
  }, [active, autoDisconnect, wsConnection]);

  // Subscribe
  useEffect(() => {
    if (connected && active) {
      if (checkForDuplicateSubscriptions) {
        const currentSubscriptions = wsConnection.getSubscriptions();
        const currentSubscription = currentSubscriptions.find(
          (sub) => sub.topic === topic,
        );
        if (currentSubscription) {
          return;
        }
      }
      wsConnection.subscribe(topic, (data) => {
        if (wsStatus === statusConst.PENDING) {
          setWsStatus(statusConst.SUCCESS);
        }
        onMessage(data);
      });
    }
    return () => {
      if (active && autoUnsubscribe) {
        wsConnection.unsubscribe(topic);
      }
    };
  }, [
    wsConnection,
    connected,
    topic,
    wsStatus,
    onMessage,
    active,
    checkForDuplicateSubscriptions,
    autoUnsubscribe,
  ]);

  //send
  useEffect(() => {
    if (connected && active) {
      beforeSend();
      wsConnection.send(
        messageMapping.endpoint,
        messageMapping.headers,
        JSON.stringify(messageMapping.payload),
      );
    }
  }, [
    active,
    beforeSend,
    connected,
    messageMapping.endpoint,
    messageMapping.headers,
    messageMapping.payload,
    wsConnection,
  ]);

  return { wsStatus, loadingMessage, connected };
};

export default useLiveLocation;
